import useSWR from 'swr';
import { ResponseObject } from '../interfaces';
import request from '../utils/request';

export interface StakeValueInfo {
  date: number;
  totalDelegatedUSD: string;
  totalRewardUSD: string;
}

/**
 * useTotalStakedValue
 */
export default function useTotalStakedValue(interval?: 7 | 30 | number) {
  return useSWR(
    interval != null && ['/api/v1/summary/totalStakeValue', interval],
    ([url, interval]) =>
      request.post<ResponseObject<StakeValueInfo[]>>(url, {
        interval,
      }),
    {
      refreshInterval: 12_000,
      keepPreviousData: true,
    }
  );
}
